import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { bawagCAConfig } from '../../../environments/environment';
import { LoginService } from '../../service/login.service';

@Component({
    selector: 'app-currentaccount-bawag',
    template: ''
})
export class CurrentAccountBawag implements OnInit {
  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.route.url.subscribe((segments) => {
      let native = segments.some((seg) => seg.path === 'native');
      this.route.queryParams.subscribe(async (params) => {
        const inApp = params['inApp'];
        const productName = params['productName'];

        if (bawagCAConfig.redirectUri) {
          if (productName === 'safe-and-cool') {
            bawagCAConfig.redirectUri = bawagCAConfig.redirectUri.replace(
              'existing',
              'safeexisting'
            );
          }

          if (native && productName) {
            bawagCAConfig.redirectUri =
              bawagCAConfig.redirectUri + '/native?productName=' + productName;
          } else if (!native && inApp && productName) {
            bawagCAConfig.redirectUri =
              bawagCAConfig.redirectUri + '?inApp=true&productName=' + productName;
          } else if (!native && !inApp && productName) {
            bawagCAConfig.redirectUri =
              bawagCAConfig.redirectUri + '?productName=' + productName;
          } else if (native && !inApp && !productName) {
            bawagCAConfig.redirectUri = bawagCAConfig.redirectUri + '/native';
          } else if (!native && inApp && !productName) {
            bawagCAConfig.redirectUri = bawagCAConfig.redirectUri + '?inApp=true';
          } else {
            bawagCAConfig.redirectUri = bawagCAConfig.redirectUri;
          }
        }
      });
    });
  }

  ngOnInit(): void {
    this.loginService.login(bawagCAConfig);
  }
}
